const eventData = {
  'Mar 10': [
    { title: 'Visionary Voyage', time: '9 AM - 11 PM', department: 'CHEMICAL' },
    { title: 'Chem AI Quest', time: '11 AM - 1 PM', department: 'CHEMICAL' },
    { title: 'Civivision', time: '10 AM - 11 AM', department: 'CIVIL' },
    { title: 'Porous Potential', time: '11 AM - 12:30 PM', department: 'CIVIL' },
    { title: 'Tech Enigma - 1', time: '9 AM - 10 AM', department: 'CSE' },
    { title: 'SQL Escape Room - 1', time: '10:15 AM - 11:15 AM', department: 'CSE' },
    { title: 'AlgoHustle - 1', time: '11:30 AM - 12:30 PM', department: 'CSE' },
    { title: 'Crack the Vault', time: '9 AM - 11 AM', department: 'ECE' },
    { title: 'Circuit Crafter -1', time: '11:30 AM - 12:00 PM', department: 'ECE' },
    { title: 'Brightest Mind -1', time: '9 AM - 10:15 AM', department: 'EEE' },
    { title: 'Unlock the Unknown', time: '10:15 AM - 11:45 AM', department: 'EEE' },
    { title: 'CADomania', time: '9 AM - 10:30 AM', department: 'MECHANICAL' },
    { title: 'Logo Auction', time: '10:30 AM - 1 PM', department: 'MECHANICAL' },
    { title: 'Metallography - 1', time: '9:30 AM - 10 AM', department: 'MME' },
    { title: 'Escape Odyssey - 1', time: '10:30 AM - 11 AM', department: 'MME' },
    { title: 'Escape Odyssey - 2', time: '11 AM - 11:30 AM', department: 'MME' },
    { title: 'Case Study', time: '12 PM - 1 PM', department: 'MME' },
    { title: 'Icon of PUC - 1', time: '9:00 AM - 9:45 AM', department: 'PUC' },
    { title: 'PROMPT & PAINT - 1', time: '9:50 AM - 10:10 AM', department: 'PUC' },
    { title: 'CineBot - 1', time: '10:15 AM - 11:45 AM', department: 'PUC' },
    { title: 'Puzzle Pinnacle - 1', time: '10:45 AM - 11:15 AM', department: 'PUC' },
    { title: 'Icon of PUC - 2', time: '11:20 AM - 12:00 PM', department: 'PUC' },
  ],
  'Mar 11': [
    { title: 'Solvers Arena', time: '9 AM - 11 AM', department: 'CHEMICAL' },
    { title: 'Read React Rearrange', time: '11 AM - 1 PM', department: 'CHEMICAL' },
    { title: 'CAD Maestro', time: '10 AM - 11 AM', department: 'CIVIL' },
    { title: 'Tech Enigma - 2', time: '9 AM - 10 AM', department: 'CSE' },
    { title: 'SQL Escape Room - 2', time: '10 AM - 11 AM', department: 'CSE' },
    { title: 'AlgoHustle - 2', time: '11:15 AM - 1:15 PM', department: 'CSE' },
    { title: 'Circuit Crafter - 2', time: '9 AM - 11 AM', department: 'ECE' },
    { title: 'Maze Masters', time: '2 PM - 4:30 PM', department: 'ECE' },
    { title: 'Voltage Vault', time: '9 AM - 5 PM', department: 'EEE' },
    { title: 'Brightest Mind - 2', time: '9 AM - 10 AM', department: 'EEE' },
    { title: 'Energy Odyssey', time: '11 AM - 12 PM', department: 'EEE' },
    { title: 'Assemble And Disassemble', time: '9 AM - 11 AM', department: 'MECHANICAL' },
    { title: 'Mech Craft', time: '11 AM - 1 PM', department: 'MECHANICAL' },
    { title: 'Meta x Word', time: '10 AM - 11 AM', department: 'MME' },
    { title: 'Metallography - 2', time: '11 AM - 1 PM', department: 'MME' },
    { title: 'PROMPT & PAINT -2', time: '9:00 AM - 9:40 AM', department: 'PUC' },
    { title: 'CineBot - 2', time: '9:40 AM - 10:40 AM', department: 'PUC' },
    { title: 'Puzzle Pinnacle - 2', time: '10:45 AM - 11:45 AM', department: 'PUC' },
    { title: 'Icon of PUC - 3', time: '12:00 PM - 1:00 PM', department: 'PUC' },
    { title: 'Envision IAS - 1', time: '2:00 PM - 3:00 PM', department: 'OPEN TO ALL' },
    { title: 'Free Fire - 1', time: '3:00 PM - 3:30 PM', department: 'OPEN TO ALL' },
    { title: 'IPL Auction - 1', time: '3:30 PM - 4:00 PM', department: 'OPEN TO ALL' },
    { title: 'Envision IAS - 2', time: '4:00 PM - 5:00 PM', department: 'OPEN TO ALL' },
    { title: 'Squid Zone - 1', time: '5:00 PM', department: 'OPEN TO ALL' },
  ],
  'Mar 12': [
    { title: 'Envision IAS - 3', time: '2:00 PM - 3:00 PM', department: 'OPEN TO ALL' },
    { title: 'Free Fire - 2', time: '2:00 PM - 2:30 PM', department: 'OPEN TO ALL' },
    { title: 'Squid Zone - 2', time: '2:30 PM - 3:30 PM', department: 'OPEN TO ALL' },
    { title: 'IPL Auction - 2', time: '3:30 PM - 5:00 PM', department: 'OPEN TO ALL' },
  ],
};
export default eventData;